import { useState, useEffect } from 'react';
import './CookieConsent.css';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Cookie consent">
      <p>
        This site uses essential cookies for security and functionality.
        By continuing, you accept our use of cookies.{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      </p>
      <button onClick={accept} className="cookie-accept">Accept</button>
    </div>
  );
}
